
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/link-demo/auth",
      function () {
        return require("private-next-pages/link-demo/auth.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/link-demo/auth"])
      });
    }
  